module.exports = __webpack_public_path__ + "img/warehouse_one.20df091f.jpg";